import m from 'mithril';
import Component_Certificate_Viewer from './component_certificate_viewer';
import i18n from "../../shared/i18n/i18n";

let reloadCallback;

function openCertificate(unit, course) {
    m.mount(document.getElementById('document-mount'), {
        view: function () {
            return m(Component_Certificate_Viewer, {
                enrolmentId: course.enrolment.id,
                unit: unit,
                callback: closeCertificate
            });
        }
    });
}

function closeCertificate() {
    m.mount(document.getElementById('document-mount'), null);
    if (reloadCallback)
        reloadCallback();
}

const Component_Unit_Actions_Certificate = {
    oninit: function (vnode) {
        let unit = vnode.attrs.unit;
        let course = vnode.attrs.course;
        let unitNumber = vnode.attrs.unitNumber;
        reloadCallback = vnode.attrs.reloadCallback;
        if (unit && course && unitNumber && unit.id === unitNumber) {
            return unit?.enrolment?.allowAccess ? openCertificate(unit, course) : '';
        }
    },
    view: function (vnode) {
        let unit = vnode.attrs.unit;
        let course = vnode.attrs.course;
        reloadCallback = vnode.attrs.reloadCallback;
        return unit?.enrolment?.allowAccess ?
            m('button', {
                onclick: function () {
                    openCertificate(unit, course);
                },
                class: unit.enrolment.isCompleted ? '' : 'btn-cta'
            }, i18n.t("view_certificate"))
            : '';
    }
};

export default Component_Unit_Actions_Certificate;
